import { Box, Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../../../shared/ui/Inputs.js';
import { Modal } from '../../../shared/ui/Modal';
import { ModalList, PreCheckError } from './spreadsheetUploadConfig.style.js';

export const BackupRollbackModal = ({
    open,
    onClose,
    loading,
    onConfirm,
    canConfirm,
    targetFileName,
    disabledMessage,
}) => {
    return (
        <Modal open={open} handleClose={onClose} width="560px">
            <Box>
                <Typography
                    variant="h5"
                    style={{ fontWeight: 700, textAlign: 'center' }}
                >
                    Confirmar backup
                </Typography>

                <Box style={{ marginTop: 12 }}>
                    <Typography
                        variant="body2"
                        style={{ color: '#6b7280', lineHeight: 1.5 }}
                    >
                        Esta ação faz um rollback do cadastro de produtos, restaurando o
                        conteúdo da tabela de produtos para o estado do último snapshot
                        criado antes de um upload com sucesso.
                    </Typography>

                    {targetFileName ? (
                        <Box style={{ marginTop: 10 }}>
                            <Typography variant="body2" style={{ lineHeight: 1.5 }}>
                                Você irá restaurar os dados para o upload com sucesso anterior
                                ao atual:
                            </Typography>
                            <Typography
                                variant="body2"
                                style={{ lineHeight: 1.5, fontWeight: 700, marginTop: 4 }}
                            >
                                {targetFileName}
                            </Typography>
                        </Box>
                    ) : null}

                    <Box style={{ marginTop: 10 }}>
                        <Typography
                            variant="body2"
                            style={{ lineHeight: 1.5, fontWeight: 700 }}
                        >
                            Importante
                        </Typography>
                        <ModalList style={{ marginTop: 6 }}>
                            <li>O rollback só funciona se existir snapshot salvo.</li>
                        </ModalList>
                    </Box>

                    {!canConfirm && disabledMessage ? (
                        <PreCheckError style={{ marginTop: 10 }}>
                            {disabledMessage}
                        </PreCheckError>
                    ) : null}
                </Box>

                <Box
                    style={{
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 18,
                        flexWrap: 'wrap',
                    }}
                >
                    <SecondaryButton type="button" onClick={onClose} disabled={loading}>
                        Cancelar
                    </SecondaryButton>
                    <PrimaryButton
                        type="button"
                        disabled={loading || !canConfirm}
                        title={
                            !canConfirm
                                ? disabledMessage || 'Rollback indisponível'
                                : loading
                                    ? 'Executando rollback…'
                                    : 'Confirmar rollback'
                        }
                        onClick={onConfirm}
                    >
                        Confirmar
                    </PrimaryButton>
                </Box>
            </Box>
        </Modal>
    );
};
